import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';

import { TTerminalType } from '../../core/terminal';
import { getTerminalTypesRequest } from '../../requests/get-terminal-types.request';
import { UiSelectTerminalType } from '../../ui/ui-select-terminal-type';

type AvailableTerminalProps = {
  value?: TTerminalType;
  onChange?: (terminalType: TTerminalType) => void;
};

export const AvailableTerminalTypes = observer(
  ({ value, onChange }: AvailableTerminalProps) => {
    const [items, setItems] = useState<TTerminalType[]>([]);
    const errorNotify = usePageNotify();

    const getTerminalTypesResource = useResource<void, TTerminalType[]>({
      request: getTerminalTypesRequest,
      errorNotify: errorNotify,
      onDone(result) {
        setItems(result);
      },
    });

    const handleChange = (values: TTerminalType) => {
      onChange && onChange(values);
    };

    const isLoading = getTerminalTypesResource.isLoading;

    useEffect(() => {
      getTerminalTypesResource.send();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <UiSelectTerminalType
        loading={isLoading}
        items={items}
        value={value}
        onChange={handleChange}
      />
    );
  }
);
